import { TextField } from "@material-ui/core";
import { KeyboardDatePicker } from "@material-ui/pickers";
import ToggleButtons from "./ToggleButtons";
import { useState } from "react";

const _spacing = "10px";

const SqForm = props => {
  const [toggleOption, setToggleOption] = useState(0);

  const handleChange = e => {
    const name = e.target.name;
    const value = e.target.value;
    // if (name === "nameWithDob") {
    //   props.setQueryState(prevState => {
    //     return { ...prevState, [name]: value, name: null, soundex: null };
    //   });
    // } else {
    props.setQueryState(prevState => {
      return {
        ...prevState,
        [name]: value,
      };
    });
    // }
  };

  const handleDateChange = (date, str) => {
    props.setQueryState(prevState => {
      return { ...prevState, dob: str };
    });
  };

  const Registration = () => {
    return (
      <TextField
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="snowmobile-registration-id"
        label="Snowmobile Registration"
        value={props?.queryState?.snowmobileRegistration?.toUpperCase() || ""}
        onChange={handleChange}
        name="snowmobileRegistration"
        helperText="Up to 10 alphanumeric characters"
        style={{ width: "45%" }}
      />
    );
  };

  const Vin = () => {
    return (
      <TextField
        variant="outlined"
        InputLabelProps={{ shrink: true }}
        margin="dense"
        id="vin-id"
        label="Snowmobile VIN"
        value={props?.queryState?.vin?.toUpperCase() || ""}
        onChange={handleChange}
        name="vin"
        helperText="Up to 20 alphanumeric characters"
        style={{ width: "45%" }}
      />
    );
  };

  const NameDob = () => {
    return (
      <>
        <TextField
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="name-with-dob-id"
          label="Name"
          value={props?.queryState?.name || ""}
          onChange={handleChange}
          name="name"
          helperText="Last name, First name Middle Initial"
          style={{ width: "45%" }}
        />
        <KeyboardDatePicker
          data-testid="dob"
          inputProps={{ "data-testid": "dob-input" }}
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Date of birth"
          value={props?.queryState?.dob || null}
          onChange={(date, str) => handleDateChange(date, str)}
          format="YYYYMMDD"
          helperText="Date format: YYYYMMDD"
          disableFuture={true}
          style={{ width: "45%" }}
        />
      </>
    );
  };

  const formOptions = [Registration, Vin, NameDob];

  return (
    <div
      data-testid="sq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <ToggleButtons
        buttons={[
          { name: "Registration" },
          { name: "Vin" },
          { name: "Name/DOB" },
        ]}
        callback={setToggleOption}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {formOptions[toggleOption] && formOptions[toggleOption]()}
      </div>
    </div>
  );
};

export default SqForm;
